// InvitationModal.jsx
import styles from "./InvitationModal.module.css";
import { CloseOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";
import { getExternalUserDetailInit } from "../../../redux/actions";

const CheckIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <polyline
      points="6,17 13,24 26,10"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function InvitationModal({
  onClose,
  title = "Invitation Sent",
  description = "Your invite has been sent to talent. You'll be able to move forward when talent accepts it.",
  ctaLabel = "Explore More Talent",
  onCta,
}) {
  const dispatch = useDispatch();
  const { id } = useParams();

  const handleClose = () => {
    dispatch(getExternalUserDetailInit(id));
    onClose();
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.backdrop} onClick={handleClose} />

      <div className={styles.modal}>
        <button className={styles.closeBtn} onClick={handleClose}>
          <CloseOutlined />
        </button>

        <div className={styles.iconCircle}>
          <CheckIcon />
        </div>

        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>

        <button className={styles.cta} onClick={onCta}>
          {ctaLabel}
        </button>
      </div>
    </div>
  );
}